module.exports = __webpack_public_path__ + "static/media/gameEnding_1.637b8a99.mp3";